import React from "react";
import "./tabs.css";
import divider from "../../assets/img/landing-page/divider.png";
import "../../assets/styles/main.css";
import "../../assets/styles/responsive.css";
const Tabs = ({ icon, heading, desc, isActive = false, onClick }) => {
  return (
    <div
      onClick={() => {
        onClick();
      }}
      className="landing-page-slider-tabs"
      style={{
        position: "relative",
        cursor: "pointer",
        height: "135px",
        marginBottom: "20px",
      }}
    >
      <div
        className="slider-tabs-icon"
        style={{ width: "35px", flexShrink: 0 }}
      >
        <div>
          {isActive ? (
            <img
              src={icon}
              style={{ width: "35px", height: "auto" }}
              alt="Icon"
            />
          ) : null}
        </div>
      </div>
      <div
        className={`slider-tabs-divider ${isActive ? "" : ""}`}
        style={{ flexShrink: 0, height: "114%" }}
      >
        <img
          src={divider}
          alt="Icon"
          style={{ height: "100%", visibility: isActive ? "" : "hidden" }}
        />
      </div>
      <div
        className="slider-tabs-text privacy-policy"
        style={{ textAlign: "left", transform: "all 0.5s" }}
      >
        <h4>{heading}</h4>
        <p style={{ lineHeight: "30px" }}> {desc}</p>
      </div>
      {isActive ? null : <div className="slider-tabs-overlay"></div>}
    </div>
  );
};

export default Tabs;
